export enum GameSettingsScreenState {
  GeneralSettings = 1,
  AssetSettings = 2,
  DrawSettings = 3,
  NotificationSettings = 4,
  LotteryLicense = 5,
  Testimonials = 6,
  GameState = 7
}
